export const StartMembershipTestIds = {
    mainScrollView: 'start-membership-main-scroll-view',
    page: 'start-membership-page',
    emailInput: 'start-membership-email-input',
    readonlyEmailInput: 'start-membership-readonly-email-input',
    passwordInput: 'start-membership-password-input',
    readonlyPasswordInput: 'start-membership-readonly-password-input',
    partnerPanel: 'start-membership-partner-panel',
    partnerCloseButton: 'start-membership-partner-close-button',
    addPartnerButton: 'start-membership-add-partner-button',
    continueButton: 'start-membership-continue-button',
} as const;
